import { gql } from "graphql-tag";

export const getHtmlSectionV2 = pageType => gql`
  fragment ${pageType}_html_section_v2 on ${pageType}BodyHtml_section_v2 {
    type
    variation {
      ... on ${pageType}BodyHtml_section_v2Default {
        primary {
          html
          src
          type
        }
      }
    }
  }`;
